export const PM = 'DM';
export const MESSAGES = 'Messages';
export const GROUPS = 'Groups';
export const SETTINGS = 'Settings';
export const NEW_MESSAGE = 'New Message';
export const CREATE_GROUP = 'Create Group';
export const JOIN_GROUP = 'Join Group';
export const ACCOUNT = 'Account';
export const SUPPORT = 'Support';
export const SUGGESTIONS = 'Suggestions';
export const DEVICES = 'Devices';
export const LOG_OUT = 'Log out';
export const SINGLE_WATCHING = 'watching';
export const SINGLE_TYPING = 'is typing';
export const PLURAL_WATCHING = 'are watching';
export const PLURAL_TYPING = 'are typing';
export const CLICK_CREATE_GROUP = 'Click Create Group';
export const CLICK_JOIN_GROUP = 'Click Join Group';
export const LOG_OUT_MESSAGE = 'Are you sure you want to logout ?';
export const NO_PM_CHATS = 'You do not have any direct messages';



// WEBPACK FOOTER //
// ./src/lang/en/left.js